import React from "react";
import { useLocation } from "react-router-dom";
import { ShieldWarning } from "@phosphor-icons/react";

const isLive = () => !/(preview\.emergentagent\.com|localhost)$/.test(window.location.hostname);

export const AdminBanner = () => {
  const { pathname } = useLocation();
  if (!pathname.startsWith("/admin")) return null;
  const live = isLive();
  return (
    <div data-testid="admin-banner" role="status" className="bg-red-700 text-white">
      <div className="container-ccc py-3 flex flex-wrap items-center gap-x-4 gap-y-1 font-semibold tracking-[0.14em] uppercase text-sm sm:text-base">
        <ShieldWarning size={22} weight="fill" />
        <span data-testid="admin-banner-title">Admin area</span>
        <span data-testid="admin-banner-env" className={`px-2.5 py-0.5 rounded-sm text-xs sm:text-sm ${live ? "bg-white text-red-700" : "bg-yellow-300 text-black"}`}>
          {live ? "Live site - real patients" : "Test copy - not the live site"}
        </span>
      </div>
    </div>
  );
};
